<template>
	<div>
		<h1 v-if="showSessionCountdown">Session Expires At: {{sessionExpiresAt}} Countdown: {{remainingTimeInSession | minutes}}</h1>
		<modal
			:show="showSessionExpiresWarningModal"
			dialog-size="md"
			name="SessionExpiresWarning"
		>
			<template slot="header">
				<h4 class="modal-title">
					{{ $t('MAIN_CONTENT.SessionTimeoutModal.sessionTimeoutModalTitle') }}
				</h4>
			</template>

			<template>
				<p v-html="$t('MAIN_CONTENT.SessionTimeoutModal.sessionTimeoutModalMessage', {remainingTimeInSession: remainingTimeInSessionAsMinutes})"></p>
			</template>

			<template slot="footer">
					<button type="button" class="btn btn-danger" data-dismiss="modal" @click="logout()">Logout</button>
					<button type="button" class="btn btn-primary" data-dismiss="modal" @click="remainLoggedIn()">Remain Logged In</button>
			</template>
		</modal>

	</div>
</template>

<script>
	import moment from 'moment';

	import { mapGetters, mapActions, mapMutations } from 'vuex';
	import Modal from 'COMMONS/shared/Modal/Modal.vue';	
	
	export default {
		name: 'SessionTimeout',
		components: {
			Modal,
		},
		data() {
			return {
				sessionExpiresSoonTimer: "",
				countdownTimer: "",
				remainingTimeInSession: 0,
			}
		},
		computed: {
			...mapGetters(['sessionExpiresAt','showSessionExpiresWarningModal']),
			showSessionCountdown(){
				return this.$store.state.debug.flags.showSessionDurationTimer.isActive;
			},
			remainingTimeInSessionAsMinutes(){
				let minute = String(Math.floor(this.remainingTimeInSession / 60));
				let second = String(this.remainingTimeInSession % 60).padStart(2, '0');

				
				return minute + ':' + second;
			}
		},
		filters: {
			minutes: function (seconds) {
				let minute = String(Math.floor(seconds / 60));
				let second = String(seconds % 60).padStart(2, '0');
				return minute + ':' + second;
			}
		},
		methods: {
			...mapActions(['logout', 'fetchToken']),
			...mapMutations(['openSessionExpiresWarningModal', 'closeSessionExpiresWarningModal']),
			remainLoggedIn(){
				this.fetchToken().then((value) => {
					this.closeSessionExpiresWarningModal();
				});
			},
		},
		watch: {
			sessionExpiresAt:{
				handler(v){
					let self = this;

					const expiration = moment(v).unix();

					clearInterval(this.countdownTimer);
					
					this.countdownTimer = setInterval(function(){
						const warningTime = 60*3;
						let currentDateTime = moment().unix();
						self.remainingTimeInSession = Math.max(0, expiration - currentDateTime);

						if( self.remainingTimeInSession <= 0 ){
							self.logout();
						}

						if( !(self.remainingTimeInSession <= 0) && !this.showSessionExpiresWarningModal && self.remainingTimeInSession <= warningTime ){
							self.openSessionExpiresWarningModal();
						}

					}, 1000);
				},
				immediate: true
			}
		}
	}
</script>
